export function formatSubscriptionDate(dateLike) {
  const date = new Date(dateLike);
  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleDateString('es-BO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function resolveSubscriptionStatus(access) {
  if (!access?.enabled || !access?.expiresAt) {
    return {
      status: 'NO_ACCESS',
      daysLeft: 0,
      expiresAt: null,
      expiresAtLabel: null,
    };
  }

  const now = new Date();
  const expires = new Date(access.expiresAt);
  const diffDays = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));
  const expiresAtLabel = formatSubscriptionDate(expires);

  if (diffDays <= 0) {
    return {
      status: 'EXPIRED',
      daysLeft: 0,
      expiresAt: access.expiresAt,
      expiresAtLabel,
    };
  }

  if (diffDays <= 7) {
    return {
      status: 'EXPIRING',
      daysLeft: diffDays,
      expiresAt: access.expiresAt,
      expiresAtLabel,
    };
  }

  return {
    status: 'ACTIVE',
    daysLeft: diffDays,
    expiresAt: access.expiresAt,
    expiresAtLabel,
  };
}

export function isSubscriptionDeniedError(error) {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || '').toLowerCase();
  return status === 403 && message.includes('suscripcion') && message.includes('vencid');
}
